module.exports = __webpack_public_path__ + "static/media/bb.d5217b04.svg";